// Side-effect import: pins Luxon's default zone to UTC (see defaultZone.ts).
// Bare import so it is never tree-shaken and runs before any DateTime is built.
import "./defaultZone.js";
// eslint-disable-next-line no-restricted-imports
import { DateTime } from "luxon";
import { getNowMs } from "./RooTimeService.js";
export const RooDateTime = new Proxy(DateTime, {
    get(target, prop, receiver) {
        // Intercept only the .now() call
        if (prop === "now") {
            return (opts) => {
                return DateTime.fromMillis(getNowMs(), opts);
            };
        }
        // Pass everything else through to the real Luxon
        return Reflect.get(target, prop, receiver);
    },
}); // Cast to maintain IDE autocomplete
//# sourceMappingURL=RooDateTime.js.map